'use client';

import useGlobalState from '@hooks/useGlobalState';
import {
  getLpProductListCols,
  getLpProductListItemListParam,
} from '@wconcept/wconcept-common/utils/lpProductListCols';
import { useState } from 'react';
import { GaLog } from '.';

interface LpProductListGaLogProps {
  readonly pageTitle: string;
  readonly params?: Record<string, string | undefined>;
  readonly isInitial?: boolean;
}

export function LpProductListGaLog({
  pageTitle,
  params,
  isInitial,
}: LpProductListGaLogProps) {
  const { isMobile } = useGlobalState();
  const [productPerView] = useState(() => getLpProductListCols());

  return (
    <GaLog
      pageTitle={pageTitle}
      params={{
        ...params,
        itemList: isMobile
          ? getLpProductListItemListParam(productPerView)
          : undefined,
      }}
      isInitial={isInitial}
    />
  );
}
